import { render, staticRenderFns } from "./FrmRecommend.vue?vue&type=template&id=1551ca26&scoped=true"
import script from "./FrmRecommend.vue?vue&type=script&lang=js"
export * from "./FrmRecommend.vue?vue&type=script&lang=js"
import style0 from "./FrmRecommend.vue?vue&type=style&index=0&id=1551ca26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1551ca26",
  null
  
)

export default component.exports